import { Popover } from "@headlessui/react";
import { createPortal } from "react-dom";
import { useRailbar } from "@circle-react/hooks/chatsV2/useRailbar";
import { Rail } from "@circle-react-uikit/Rail";

interface RailBarPortalProps {
  children: React.ReactNode;
  isFullWidth?: boolean;
  isLoading?: boolean;
  loaderVariant?: "rail-profile" | "rail-member-list";
  noBorderLeft?: boolean;
  position?: "header" | "content" | "portal" | "drawer";
}

export const RailBarPortal = ({
  position = "header",
  children,
  ...props
}: RailBarPortalProps) => {
  const { shouldShowRailBar = true } = useRailbar();

  const selectorQuery = `#rail-bar-${position}`;
  const portalElement = document.querySelector(selectorQuery);
  if (!portalElement) {
    return null;
  }
  return (
    <>
      {createPortal(
        <Popover>
          <Popover.Panel as="div" static={shouldShowRailBar}>
            <Rail {...props}>{children}</Rail>
          </Popover.Panel>
        </Popover>,
        portalElement,
      )}
    </>
  );
};
